import {
  AUTOMATION_STEPS,
  defaultTrigger,
  defaultVariableDefinition,
  STEP_NODE_TYPES,
} from '../steps';

// Test layouts:
// - One or many triggers
// - Zero or many steps
// - One or many root steps (empty parentKey)
export default {
  triggers: [
    {
      id: 'trigger1',
      type: AUTOMATION_STEPS.manual.type,
    },
    {
      id: 'trigger2',
      type: AUTOMATION_STEPS.manual.type,
    },
  ],
  steps: [
    {
      id: 'step1',
      parentKey: null,
      type: AUTOMATION_STEPS.condition.type,
    },
    {
      id: 'step2',
      parentKey: null,
      type: AUTOMATION_STEPS.goal.type,
    },
    {
      id: 'step3',
      parentKey: 'step1',
      type: STEP_NODE_TYPES.ACTION,
    },
    {
      id: 'step4',
      parentKey: 'step3',
      type: 'split_test',
    },
  ],
};

export const newAutomation = {
  triggers: [defaultTrigger],
  steps: [],
  variables: [defaultVariableDefinition],
};

export const automationStats = {
  active: 1001,
  completed: 27210000,
  paused: 44000,
};
